module.exports = __webpack_public_path__ + "static/media/clear-search.9c9839e3.svg";